import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { DateTime } from "luxon";
import { MonthPickerCustomHeader } from "./monthpickercustomheader.jsx";
import { DatePickerWrapper } from "./datepickerwrapper.jsx";
import DatePicker from "react-datepicker";
import i18n from "../../i18n";
import { registerLocale } from "react-datepicker";
import fi from "date-fns/locale/fi";
import sv from "date-fns/locale/sv";
import enGB from "date-fns/locale/en-GB";
import nl from "date-fns/locale/nl";

export const FullCalendarMonthPicker = ({ calendarRef, title }) => {
  const calendarApi = calendarRef.getApi();
  const [selectedDate, setSelectedDate] = useState(new Date());

  registerLocale("fi", fi);
  registerLocale("sv", sv);
  registerLocale("en", enGB);
  registerLocale("nl", nl);

  useEffect(() => {
    calendarApi.gotoDate(DateTime.fromJSDate(selectedDate).toISODate());
  }, [selectedDate]);

  return (
    <DatePickerWrapper>
      <DatePicker
        selected={calendarApi.getDate()}
        onChange={(date) => {
          setSelectedDate(date);
        }}
        dateFormat="MM/yyyy"
        showMonthYearPicker
        showMonthYearDropdown
        showFourColumnMonthYearPicker
        showDateSelect={false}
        showTimeInput={false}
        showTimeSelect={false}
        locale={i18n.resolvedLanguage}
        renderCustomHeader={({ date, increaseYear, decreaseYear }) =>
          <MonthPickerCustomHeader date={date}
            increaseYear={increaseYear}
            decreaseYear={decreaseYear}/>
        }
        customInput={
          <Dropdown.Toggle
            variant="outline-secondary"
            className="text-color-purple-600 bg-white fw-bold"
          >
            {title}
          </Dropdown.Toggle>
        }
      />
    </DatePickerWrapper>
  );
};

